
export const keySpazi = {
  convivenza: "spaziConvivente",
  convivenzaRidotta: "spaziConvivenzaRidotta",
};

export const nameKey = {
  convivenza: "convivenza",
  convivenzaRidotta: "convivenzaRidotta",
  nonConviventi: "nonConviventi",
  presenzaNotturna: "presenzaNotturna",
  weekend: "weekend",
  assistenzaNotturna: "assistenzaNotturna"
};

export const nameKeyStipendio = {
  convivenza: "stipendioConvivente",
  convivenzaRidotta: "stipendioConvivenzaRidotta",
  nonConviventi: "stipendioNonConvivente",
  presenzaNotturna: "stipendioPresenzaNotturna",
  weekend: "stipendioWeekend",
  assistenzaNotturna: "stipendioAssistenzaNotturna"
};